import Helper from '@ember/component/helper';
import { inject as service } from '@ember/service';
import { SCHOOL_TZ } from 'e-commerce/lib/school-day';

/**
 * Formatta una data (stringa 'YYYY-MM-DD' o Date) nel giorno localizzato per la
 * lingua attiva, es. "sab 12 dicembre 2026" (it), "Sat 12 December 2026" (en).
 * Usa ember-intl (Intl.DateTimeFormat del browser) → multilingua senza dipendere
 * dal locale globale di moment.
 */
export default class FormatDayLocaleHelper extends Helper {
  @service intl;

  compute([date], { weekday = 'short' } = {}) {
    if (!date) {
      return null;
    }
    // The day is the ski school's (Europe/Rome), not the visitor's: a departure sent
    // as "2027-02-15T00:00:00+01:00" read in the browser zone printed 14/02 for a
    // customer on Europe/London (POP-698). A bare 'YYYY-MM-DD' is taken at 12:00 UTC,
    // which is the same calendar day in Rome.
    const d = typeof date === 'string' && /^\d{4}-\d{2}-\d{2}$/.test(date)
      ? new Date(`${date}T12:00:00Z`)
      : new Date(date);
    if (isNaN(d.getTime())) {
      return date;
    }
    const opts = { day: '2-digit', month: 'long', year: 'numeric', timeZone: SCHOOL_TZ };
    if (weekday) {
      opts.weekday = weekday;
    }
    return this.intl.formatDate(d, opts);
  }
}
